import React from "react";
import styles from "./loader.module.scss";
import { Spinner, mergeClasses } from "@fluentui/react-components";

interface LoaderProps {
    text: string;
    additionalClassName?: string;
}

const Loader: React.FC<LoaderProps> = (props: LoaderProps) => {
    return (
        <div className={mergeClasses(styles.wrapper, props.additionalClassName)}>
            <Spinner label={props.text} />
        </div>
    );
};

export default Loader;
